import React from 'react';

export const IconList = () => (
    <svg width="17" height="12" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="1.2" cy="1.2" r="1.2" fill="white" />
        <circle cx="1.2" cy="6" r="1.2" fill="white" />
        <circle cx="1.2" cy="10.8" r="1.2" fill="white" />
        <rect x="4.79999" width="12" height="2.4" rx="1.2" fill="white" />
        <rect x="4.79999" y="4.8" width="12" height="2.4" rx="1.2" fill="white" />
        <rect x="4.79999" y="9.6" width="12" height="2.4" rx="1.2" fill="white" />
    </svg>
);
